(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ride2fun-kit-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-r2f-gallery]').forEach((gallery) => {
    if (gallery.dataset.r2fReady === 'true') return;
    gallery.dataset.r2fReady = 'true';
    const mainImage = gallery.querySelector('.r2f-detail__main-image img');
    const thumbnails = gallery.querySelectorAll('[data-r2f-thumbnail]');
    if (!mainImage) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const swapImage = () => {
          mainImage.src = thumbnail.dataset.fullImage;
          mainImage.srcset = '';
          mainImage.alt = thumbnail.dataset.imageAlt || '';
          thumbnails.forEach((item) => item.setAttribute('aria-current', 'false'));
          thumbnail.setAttribute('aria-current', 'true');
        };

        if (document.startViewTransition) {
          document.startViewTransition(swapImage);
        } else {
          swapImage();
        }
      });
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ride2fun-v2-product-detail"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-r2f-gallery]').forEach((gallery) => {
    if (gallery.dataset.r2fReady === 'true') return;
    gallery.dataset.r2fReady = 'true';
    const mainImage = gallery.querySelector('.r2f-detail__main-image img');
    const thumbnails = gallery.querySelectorAll('[data-r2f-thumbnail]');
    if (!mainImage) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const swapImage = () => {
          mainImage.src = thumbnail.dataset.fullImage;
          mainImage.srcset = '';
          mainImage.alt = thumbnail.dataset.imageAlt || '';
          thumbnails.forEach((item) => item.setAttribute('aria-current', 'false'));
          thumbnail.setAttribute('aria-current', 'true');
        };

        if (document.startViewTransition) {
          document.startViewTransition(swapImage);
        } else {
          swapImage();
        }
      });
    });
  });

  document.querySelectorAll('.r2f-stock-form').forEach((form) => {
    const status = form.querySelector('.r2f-stock-status');
    const refresh = () => {
      const choice = form.querySelector('[name="properties[Personnalisation]"]');
      if (!choice) return;
      const copy = form.querySelector('.r2f-detail__personalization').dataset;
      const setText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
      setText(form.querySelector('.r2f-io-personalization-choice .spb-label-tooltip > label'), copy.choiceLabel);
      setText(form.querySelector('.r2f-io-personalization-text .spb-label-tooltip > label'), copy.textLabel);
      form.querySelectorAll('[name="properties[Personnalisation]"]').forEach(input => {
        const label = input.closest('label');
        const text = input.value === 'Non' ? copy.choiceNo : copy.choiceYes;
        if (label) Array.from(label.childNodes).filter(node => node.nodeType === 3).forEach(node => {
          if (node.textContent !== text) node.textContent = text;
        });
      });
      const textInput = form.querySelector('.r2f-io-personalization-text input[type="text"]');
      if (textInput) textInput.placeholder = copy.textPlaceholder;
      form.querySelectorAll('[data-r2f-purchase]:not([data-r2f-unavailable])').forEach(button => button.disabled = false);
      status.hidden = true;
      const field = form.querySelector('[name="properties[Texte personnalisation]"]');
      if (field) field.maxLength = 15;
    };
    const observer = new MutationObserver(refresh);
    observer.observe(form, { childList: true, subtree: true });
    refresh();
  });

  } catch(e) { console.error(e); }
})();
})();
